import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ExplicitDatePicker from 'js/components/explicit_date_picker/index.js';

export default class AgeEntry extends Component {
    static propTypes = {
        handleChange: PropTypes.func.isRequired
    };

    static defaultProps = {
        autofill: true
    };

    /**
     * @param {Event} e
     * @memberof AgeEntry
     */
    handleEntry = e => {
        const {handleChange} = this.props;

        handleChange(e);
    };

    render() {
        const {value} = this.props;
        const label = 'Date of Birth';

        return (
            <div className="form-group smart-questions-subform">
                <div className="text-center">
                    <ExplicitDatePicker value={value} label={label} onChange={this.handleEntry} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/smart_question/defaults/age_entry.js